import http from '../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_SHOPS}/filter-norma`

export default (queryParams = {}) => http.get(`${api}`, { params: { ...queryParams } })
